<template>
  <div>
<!--    <el-row :gutter="16" type="flex" align="middle" justify="space-between">-->
<!--      <el-col :span="4">-->
<!--        <el-input v-model="crawlerVersion" clearable placeholder="输入采集日期">-->
<!--        </el-input>-->
<!--      </el-col>-->
<!--&lt;!&ndash;      <el-col :span="4">&ndash;&gt;-->
<!--&lt;!&ndash;        <el-input v-model="keyword" clearable placeholder="输入检索词">&ndash;&gt;-->
<!--&lt;!&ndash;        </el-input>&ndash;&gt;-->
<!--&lt;!&ndash;      </el-col>&ndash;&gt;-->
<!--      <el-col :span="4">-->
<!--        <el-button icon="el-icon-download" @click="exportSelectedData" alt=""-->
<!--        >导出所有数据</el-button-->
<!--        >-->
<!--      </el-col>-->

<!--    </el-row>-->
    <el-row :gutter="16">
      <el-col :span="5">
        <el-button
          type="warning"
          icon="el-icon-refresh"
          size="mini"
          @click="queryAllMetas"
          >刷新搜索词列表</el-button
        >
        <el-button
          type="warning"
          icon="el-icon-refresh"
          size="mini"
          @click="refreshGoodsList"
          >刷新商品列表{{
            totalItems
          }}</el-button
        >
        <el-table
          :data="metas"
          class="el-table-clone"
          :row-class-name="tableRowStyle"
          style="width: 100%; margin-top: 14px"
          :height="tableHeight"
          @row-click="queryGoods"
        >
          <el-table-column
            type="index"
            label="序号"
            align="center"
          ></el-table-column>
          <el-table-column prop="searchDate" label="日期"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
          <el-table-column label="橱窗主昵称">
            <template slot-scope="scope">
              <span v-if="scope.row.extraInfo === undefined">{{scope.row.keyword}}</span>
              <span v-if="scope.row.extraInfo !== undefined">{{scope.row.extraInfo.nickname}}</span>
            </template>
          </el-table-column>
<!--          <el-table-column prop="keyword" label="检索词"> </el-table-column>-->
        </el-table>
      </el-col>
      <el-col :span="19">
        <el-pagination
          background
          @current-change="queryGoodsPage"
          layout="prev, pager, next"
          class="el-pagination-douyin"
          :total="totalItems"
          :page-size="pageSize"
        >
        </el-pagination>
        <el-table :data="datas" :height="tableHeight" style="width: 100%">
          <el-table-column prop="billboardUserName" label="橱窗主">
          </el-table-column>
          <el-table-column prop="goodsTitle" label="商品标题">
          </el-table-column>
          <el-table-column prop="goodsId" label="商品ID"> </el-table-column>
          <el-table-column prop="goodsLink" label="商品连接"> </el-table-column>
          <el-table-column label="现价/原价">
            <template slot-scope="scope">
              {{ scope.row.goodsCurrentPrice }}
            </template>
          </el-table-column>
          <el-table-column prop="goodsImages" label="主图链接">
            <template slot-scope="scope">
              <img
                :src="scope.row.goodsImages"
                alt=""
                style="width: 100px; height: 100px"
              />
            </template>
          </el-table-column>
          <el-table-column prop="goodsSaleCount" label="销量">
          </el-table-column>
          <el-table-column prop="shopId" label="店铺id"></el-table-column>
          <el-table-column prop="shopKeeper" label="掌柜名"></el-table-column>
          <el-table-column prop="shopName" label="店铺名"> </el-table-column>
          <el-table-column prop="shopLink" label="店铺链接"> </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from "axios";
// import { MessageBox } from "element-ui";


export default {
  name: "douyinGoodsItem",
  props: {
    msg: String,
  },
  data() {
    return {
      formInline: {
        taskNo: "",
      },
      metas: [],
      crawlerVersion: null,
      historyVersions: [],
      taskInfo: null,
      brand_Name: "输入任务号查询",
      spiderKeyword: "",
      source: "",
      currentPage: 1,
      totalItems: 0,
      datas: [],
      allGoods: [],
      pageSize: 50,
      selectSearchId: null,
      value: "",
      tableHeight: 300
    };
  },
  computed: {
    uploadDataBtn: function () {
      return this.datas.length === 0;
    },
  },
  // 注销window.onresize事件
  beforeRouteLeave(to, from, next) {
    //离开组件的时候触发
    window.onresize = null;
    next();
  },
  created() {
    this._getTableHeight();
  },
  methods: {
    handleDelete(index, row) {
      const self = this;
      this.$confirm("此操作将永久删除该组数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          axios({
            method: "post",
            url:
              "/api/douyin/deleteSearchGoods?searchId=" +
              row.searchId,
          }).then((res) => {
            console.log("删除数据>>>", res.data.status.code);
            if (res.data.status.code === "0") {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              self.queryAllMetas();
              self.datas = [];
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    selectCrawlerVersion(selectedVersion) {
      this.crawlerVersion = selectedVersion;
    },
    exportSelectedData(){

    },
    // queryTaskInfo() {
    //   const _that = this;
    //   _that.value = null;
    //   if (_that.formInline.taskNo == "") {
    //     alert("请输入任务号");
    //   } else {
    //     let data = { taskNo: _that.formInline.taskNo.trim(), platformId: 119 };
    //     axiosGetTaskInfo(data).then((res) => {
    //       var code = res.data.status.code;
    //       if (code == 0) {
    //         // if (res.data.result.source == 3){
    //         //     MessageBox.alert("暂不支持小捕快任务补数据")
    //         // } else {
    //         _that.taskInfo = res.data.result;
    //         _that.brand_Name = res.data.result.brandName;
    //         // _that.spiderKeyword = res.data.result.spiderKeyword
    //         _that.source = res.data.result.source;
    //         // const brandid = res.data.result.brandId
    //         _that.getCrawlerVersion();
    //         // }
    //       } else if (code == -1) {
    //         var mes = res.data.status.message;
    //         MessageBox.alert(mes);
    //       }
    //     });
    //   }
    // },
    // getCrawlerVersion() {
    //   var that = this;
    //   let data = { taskNo: that.formInline.taskNo.trim(), platformId: 119 };
    //   let result = axiosGetCrawlerVersion(data);
    //   result.then((res) => {
    //     that.historyVersions = [];
    //     that.crawlerVersion = res.data.result[0];
    //     for (var item in res.data.result) {
    //       let obj = {
    //         value: res.data.result[item],
    //         label: item,
    //       };
    //       that.historyVersions.push(obj);
    //     }
    //   });
    // },
    queryAllMetas() {
      const _that = this;
      axios({
        method: "get",
        url: "/api/douyin/searchMetas?type=billboard",
      }).then((res) => {
        if (res.data.status.code === "0") {
          _that.metas = res.data.data.reverse();
          console.log("\nmeta>>>>", _that.metas);
        }
      });
    },
    queryGoods(row) {
      this.currentPage = 1;
      this.selectSearchId = row.searchId;
      this.queryAllGoods(this.selectSearchId);
      this.paginateQuery(this.selectSearchId, 1);
    },
    tableRowStyle({ row }) {
      if (row.searchId == this.selectSearchId) {
        return "table-row-search";
      }
    },
    queryGoodsPage(pageNum) {
      this.currentPage = pageNum;
      this.paginateQuery(this.selectSearchId, pageNum);
    },
    queryAllGoods(searchId) {
      if (searchId == null || searchId == undefined) {
        return;
      }
      const _that = this;
      axios({
        method: 'get',
        url: '/api/douyin/queryAllGoods?searchId=' + searchId ,
      }).then(res => {
        if (res.data.status.code === '0') {
          _that.allGoods = res.data.data;
        }
      });
    },
    paginateQuery(searchId, page) {
      if (searchId == null || searchId == undefined) {
        return;
      }
      const _that = this;
      axios({
        method: "get",
        url:
          "/api/douyin/queryPageGoods?searchId=" +
          searchId +
          "&page=" +
          page,
      }).then((res) => {
        if (res.data.status.code === "0") {
          const resObj = res.data.data;
          _that.totalItems = resObj.totalDocs;
          _that.datas = resObj.docs;
        }
      });
    },
    refreshGoodsList() {
      this.paginateQuery(this.selectSearchId, 1);
    },
    _getTableHeight() {
      let tableH = 210;
      let tableHeightDetil = window.innerHeight - tableH;
      if (tableHeightDetil <= 300) {
        this.tableHeight = 300;
      } else {
        this.tableHeight = window.innerHeight - tableH;
      }
    },
  },
  mounted() {
    var _that = this;
    _that.queryAllMetas();
    window.onresize = () => {
      if (_that.resizeFlag) {
        clearTimeout(_that.resizeFlag);
      }
      _that.resizeFlag = setTimeout(() => {
        _that._getTableHeight();
        _that.resizeFlag = null;
      }, 100);
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
.el-pagination-douyin {
    margin: 0px 10px 10px 10px;
}
.el-form-item {
    margin-bottom: 10px;
}
</style>

<style >
.table-row-search {
  background-color: #409eff !important;
  font-weight: bold;
}
</style>
